module.exports = __webpack_public_path__ + "media/images/sp/specials/common/present_meme-5657c027047e4886d568dbada50aa2eb.jpg";